<template>
  <div class="pageContainer">
    <ReportsHomeV2 title="Job Sheet" placeholder="Job No" :inputValue.sync="jobNo" :shareContent="shareContent" @generateReport="generateReport" @shareReport="shareReport" ref="mainReport"> </ReportsHomeV2>

    <Loader :isVisible.sync="isLoading" :loadingText="loadingText" :isFullScreen="true" />
    <PopupV2 :type="popupType" :show="showPopup" :title="popupTitle" :content="popupContent" @buttonClicked="showPopup = false"></PopupV2>
  </div>
</template>

<script>
/* eslint-disable */
import ReportsHomeV2 from '@/pages/ReportsV2/ReportsHome';

export default {
  components: {
    ReportsHomeV2
  },
  data: function() {
    return {
      isLoading: false,
      loadingText: '',

      transModeList: [],

      popupType: 'error',
      showPopup: false,
      popupTitle: '',
      popupContent: '',

      jobNo: '',
      jsReportdata: {},
      templateID: 'ofztrcpu5B',

      shareContent: {},
    }
  },
  props: {
  },
  methods: {
    formatDateTime: function(dateTime, format) {
      if (!dateTime) // if API didn't return a date, dont assign anything
        return; // returning null here would create another field in the data with a null value

      return this.$dateTime.getDateTime(new Date(dateTime), format);
    },
    getJobDetails: async function() {
      let loginDetails = await this.$apiCallV2('/Login/GetDetails');
      try { // call API to get details about job with the specified job number passed in URL query
        var jobDetails = await this.$apiCallV2(`/Report/GetJobDetails?config=${loginDetails.ConfigCode}&userID=${loginDetails.LoginUserId}&jobno=${this.jobNo}&rpt=RptJobContainerAttach`);
      } catch (e) {
        console.log(e);
      }
      
      if (jobDetails.length == 0) { // no job with that job number found
        this.isLoading = false;
        this.showPopup = true;
        this.popupTitle = 'Job Not Found';
        this.popupContent = `No Job with Job No. '${this.jobNo}' found.`;
        return false; // error encountered, return false
      }
      
      jobDetails.JobDetails.Job['companyName'] = loginDetails.CoName; // append company name

      // get user's preferred date format from vuex state
      let preferredDateFormat = this.$store.state['preferredDateFormat'];

      // format all dates that will be displayed on the report to follow the user's preferred date format
      jobDetails.JobDetails.Job['Job Time'] = this.formatDateTime(jobDetails.JobDetails.Job['Job Time'], `${preferredDateFormat} HH:mm`);
      jobDetails.JobDetails.Job['Closing Time'] = this.formatDateTime(jobDetails.JobDetails.Job['Closing Time'], `${preferredDateFormat} HH:mm`);
      jobDetails.JobDetails.Job['POL ETA'] = this.formatDateTime(jobDetails.JobDetails.Job['POL ETA'], `${preferredDateFormat} HH:mm`);
      jobDetails.JobDetails.Job['POL ETD'] = this.formatDateTime(jobDetails.JobDetails.Job['POL ETD'], `${preferredDateFormat} HH:mm`);
      jobDetails.JobDetails.Job['POD ETA'] = this.formatDateTime(jobDetails.JobDetails.Job['POD ETA'], `${preferredDateFormat} HH:mm`);
      jobDetails.JobDetails.Job['Final Dest ETA Time'] = this.formatDateTime(jobDetails.JobDetails.Job['Final Dest ETA Time'], `${preferredDateFormat} HH:mm`);

      if (jobDetails.JobDetails.Job['Documents']) {
        for (let doc of jobDetails.JobDetails.Job['Documents'])
          doc['Doc Rec Date'] = this.formatDateTime(doc['Doc Rec Date'], preferredDateFormat); // date only, no time
      }

      // append current time
      jobDetails.JobDetails.Job['timePrinted'] = this.$dateTime.getDateTime(new Date(), `${preferredDateFormat} HH:mm`);

      if (jobDetails.JobDetails.Job['ContDetail']) {
        let showRF = jobDetails.JobDetails.Job['ContDetail'].filter(c => c['Cont Type'] == 'RF' || c['Cont Type'] == 'HRF');
        jobDetails.JobDetails.Job['showRF'] = showRF.length > 0;
        
        let showSL = jobDetails.JobDetails.Job['ContDetail'].filter(c => c['Delivery Type'] == 'SL');
        jobDetails.JobDetails.Job['showSL'] = showSL.length > 0;
      }

      jobDetails.JobDetails.Job['shipCallNoLabel'] = this.getPlaceholders(jobDetails.JobDetails.Job['Trans Mode'], 'ShipCallNo');
      jobDetails.JobDetails.Job['vesselIDLabel'] = this.getPlaceholders(jobDetails.JobDetails.Job['Trans Mode'], 'VesselID');
      jobDetails.JobDetails.Job['vesselNameLabel'] = this.getPlaceholders(jobDetails.JobDetails.Job['Trans Mode'], 'VesselName');
      jobDetails.JobDetails.Job['shippingAgentLabel'] = this.getPlaceholders(jobDetails.JobDetails.Job['Trans Mode'], 'ShippingAgent');
      jobDetails.JobDetails.Job['shipLineCodeLabel'] = this.getPlaceholders(jobDetails.JobDetails.Job['Trans Mode'], 'ShipLineCode');
      jobDetails.JobDetails.Job['demurrageDateLabel'] = this.getPlaceholders(jobDetails.JobDetails.Job['Trans Mode'], 'DemurrageDate');
      jobDetails.JobDetails.Job['detentionDateLabel'] = this.getPlaceholders(jobDetails.JobDetails.Job['Trans Mode'], 'DetentionDate');
      jobDetails.JobDetails.Job['closingTimeLabel'] = this.getPlaceholders(jobDetails.JobDetails.Job['Trans Mode'], 'ClosingTime');

      this.jsReportdata = jobDetails.JobDetails.Job;
      return true; // no errors, return true
    },
    getPlaceholders: function(transmode, transmodeKey) {
      if (transmode) { // if selectedObject is NOT null
        let selectedTransMode = this.transModeList.find(t => t['Trans Mode'] == transmode);
        if (selectedTransMode) {
          let placeholder = selectedTransMode[transmodeKey];
          if (placeholder) {
            return placeholder;
          }
        }
      }

      switch (transmodeKey) { // defaults
        case 'ShipCallNo': return "Ship Call #";
        case 'VesselID': return "Vessel ID";
        case 'VesselName': return "Vessel Name";
        case 'ShippingAgent': return "Shipping Agent";
        case 'ShipLineCode': return 'Shipping Line';
        case 'DemurrageDate': return 'Demurrage';
        case 'DetentionDate': return 'Detention';
      }
    },
    generateReport: async function() {
      this.isLoading = true;
      this.loadingText = "Getting Job Details";
      if (await this.getJobDetails()) {
        this.loadingText = "Generating Report";
        await this.$refs['mainReport'].generateReport(this.templateID, this.jsReportdata);
        this.shareContent = {
          subject: `Job Sheet Report - ${this.jobNo}`,
          body: `The Job Sheet report for Job ${this.jobNo} is available at {link}`
        }
        this.isLoading = false;
      }
    },
    shareReport: async function() {
      this.isLoading = true;
      this.loadingText = 'Generating Link';

      var loginDetails = await this.$apiCallV2('/Login/GetDetails');
      let fileName = `${loginDetails['ConfigCode']}_${loginDetails['LoginUserId']}_JobSheet_${this.jobNo}_${this.$dateTime.getDateTime(new Date(), 'yyyyMMddHHmm')}`;
      await this.$refs['mainReport'].generateShareLink(fileName, loginDetails['ConfigCode']);

      this.isLoading = false;
    },
  },
  async mounted() {
    let jobNo = this.$route.query['jobNo'];
    
    this.$fullscreenLoading('Getting Trans Mode');
    this.transModeList = await this.$apiCallV2('/Master/GetListMaster?save=true', { masterfile: 'transmode' });
    this.$fullscreenLoading();

    if (jobNo) {
      this.jobNo = jobNo;
      await this.generateReport();

      setTimeout(() => { // only automatically prints once when loading the page
          this.$refs['mainReport'].printReport(); // clicking generate report won't auto print
      }, 100);
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.pageContainer {
  height: 100%;
  width: 100%;
}

</style>